module.exports = __webpack_public_path__ + "img/titleist_back_img1.9194d9ff.jpg";